import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RecommendWrapper, FlowerItem } from './DashboardSearchRecommendStyle';
import { useNavigate } from 'react-router-dom';
import { DashBoardCreators, resetFlowerSearchData } from 'redux/modules/dashboard';
import { useDispatch } from 'react-redux';
// import { DashBoardCreators } from "redux/modules/dashboard";
// import { useDispatch } from "react-redux";

const DashboardSearchRecommend = () => {
   let navigate = useNavigate();

   const handleClick = (name, page) => {
      navigate(`/dashboard/${name}/${page}`);
   };

   return (
      <RecommendWrapper>
         <h2>추천 검색어</h2>
         <FlowerItem>
            <div onClick={() => handleClick('올스타', 0)}>올스타</div>
            <div onClick={() => handleClick('장미', 0)}>장미</div>
            <div onClick={() => handleClick('핑크요요', 0)}>핑크요요(sp)</div>
            <div onClick={() => handleClick('메이지', 0)}>메이지</div>
            <div onClick={() => handleClick('다빈치', 0)}>다빈치</div>
         </FlowerItem>
      </RecommendWrapper>
   );
};

export default DashboardSearchRecommend;
